<template>
<!--  <test-route msg="页面跳转路由"/>-->
  <home-container></home-container>
</template>

<script>
import TestRoute from './components/TestRoute.vue'
import HomeContainer from './components/HomeContainer.vue'

export default {
  name: 'App',
  components: {
    HomeContainer
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  display: flex;
  flex-direction: column;
  height: 100%;
}
</style>
